import MainLayout from '../../components/layouts/MainLayout';

const PostComplete = () => {

  return(
    <MainLayout>
      <div className='post__comp'>
        <h2 className='login__ttl'>決済に失敗しました</h2>
        <div className='post__comp-cont'>
          <span>My Pageの編集より再度決済をお試しください</span>
        </div>
        <a href='/mypage'>My Pageへ</a>
      </div>
    </MainLayout>
  );
};

export default PostComplete;
